<div class="form-field-wrapper">
  <div class="d-flex mb-2 responsive-field" [ngClass]="{ 'label-top-position': isLabelTopPosition }">

    <label class="form-field-label form-field-label__overview"  [ngClass]="{ 'required': isRequired }">
      <app-input-helper-text [helpText]="helpText"></app-input-helper-text>
      {{ label }}
    </label>
    <div
      class="w-100 select-form-field-inline select-form-field-inline__case-status"
      [class]="'select-form-field-inline__case-status--background-' + itemClass"
    >
      <ng-select
        [class]="'select-form-field ' + customClass"
        [items]="items"
        [bindLabel]="bindLabel"
        [bindValue]="bindValue"
        [clearable]="clearable"
        [searchable]="searchable"
        [formControl]="formControl"
        [placeholder]="placeholder | translate"
        [ngClass]="{ 'select-required': errorText,  'disabled-select': isDisabledField }"
        (change)="change($event)"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="d-flex align-items-center">
            <span class="status-item">{{item[optionItem]}}</span>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-index="index">
          <div class="d-flex align-items-center">
            <span>{{item[optionItem]}}</span>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>

  @if (errorText) {
    <span class="form-field-info required-label"> {{ errorText | translate }}</span>
  }

  @if (infoText && !errorText) {
    <span class="form-field-info">{{ infoText }}</span>
  }
</div>

